module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-305.6ba3963.woff2";